<template>
  <div id="app">
    <div class="loading"
         v-if="loadingShow">
      <van-loading size="64px"
                   text-size="30px"
                   vertical>{{loadingTitle}}</van-loading>
    </div>
    <router-view />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import { Loading } from 'vant'
Vue.use(Loading)
export default {
  computed: {
    ...mapState({
      // 箭头函数可使代码更简练
      loadingShow: state => state.global.loadingShow,
      loadingTitle: state => state.global.loadingTitle
    })
  },
  methods: {
  },
  created () {
    // console.log('clientWidth', document.documentElement.clientWidth)
    if (document.documentElement.clientWidth <= 768) {
      this.$store.commit('global/SET_VALUE', { name: 'isPhone', value: true })
    } else {
      this.$store.commit('global/SET_VALUE', { name: 'isPhone', value: false })
    }
  }
}
</script>
<style lang="less">
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.click_able {
  cursor: pointer;
}
div {
  box-sizing: border-box;
}

* {
  padding: 0;
  margin: 0;
}
.scrollbar {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 15px;
    height: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #DDDDDD;
    background-clip: padding-box;
    border: 3px solid transparent;
    border-radius: 7px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(221, 221, 221, 0.9);
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-track:hover {
    background-color: #f8fafc;
  }
}
</style>
